import htmlToText from "html-to-text";
import React, { Component, Fragment } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { connect } from "react-redux";
import { compose } from "redux";
import { change, Field, getFormValues, reduxForm, reset } from "redux-form";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  FormSelect,
  FormInput,
} from "shards-react";
import { sendEmail } from "../../../../pages/Dashboard/Complaint/complaintActions";
import TextInput from "../../../form/TextInput";
import { withFirestore } from "react-redux-firebase";
import { closeModal } from "../../modalActions";
import FileUploader from "../../../form/FileUploader";
import { uploadFile } from "../../../../pages/FileUpload/fileUploadActions";

const mapState = (state, ownProps) => {
  const id = ownProps.complaintId;
  const user = state.firebase.profile;
  const complaint = ownProps.complaint;
  const companies = state.firestore.ordered.companies;

  return {
    id,
    user,
    complaint,
    companies,
    formStates: getFormValues("emailForm")(state) || { html: "" },
  };
};

const actions = {
  sendEmail,
  closeModal,
  change,
  uploadFile,
};

class AgentEmailForm extends Component {
  state = {
    toWhom: "",
    to: "",
    cc: {
      selectedOption: "",
      customEmail: "",
    },
    options: [],
    company: "",
    contactPersons: [],
    contactPerson: "",
    files: [],
    addMoreFile: false,
    fileUploader: [],
    htmlText: "",
  };

  async componentDidUpdate() {
    if (this.state.toWhom === "company") {
      this.props.firestore.get({
        collection: "companies",
        storeAs: "companies",
      });
    }
  }
  renderQuill = ({ input }) => {
    if (input.name === "html") {
      return (
        <ReactQuill
          formats={this.formats}
          modules={this.modules}
          value={this.state.htmlText || ""}
          onChange={(newValue, delta, source) => {
            this.setState({ ...this.state, htmlText: newValue });
            input.onChange(newValue);
          }}
          onBlur={(range, source, quill) => {
            input.onBlur(quill.getHTML());
          }}
        />
      );
    }
  };
  onFormSubmit = (e) => {
    e.id = this.props.complaint.id;
    e.status = this.props.complaint.status;
    e.text = htmlToText.fromString(e.html);
    e.html = this.state.htmlText;
    e.to = this.state.to;
    e.files = this.state.files;
    e.bcc = "digital@nccc.org.my";
    const { customEmail, selectedOption } = this.state.cc;
    e.cc = (customEmail || "") + (selectedOption ? `,${selectedOption}` : "");

    console.log("CC", e.cc);
    //console.log(e);

    this.props.sendEmail(e).then(() => {
      this.props.dispatch(reset({ form: "emailForm" }));
      this.props.closeModal();
    });
  };

  handleCCSelect = (event) => {
    const selectedOption = event.target.value;
    this.setState((prevState) => ({
      cc: {
        ...prevState.cc,
        selectedOption,
      },
    }));
  };

  handleCCTextInput = (event) => {
    const customEmail = event.target.value;
    this.setState((prevState) => ({
      cc: {
        ...prevState.cc,
        customEmail,
      },
    }));
  };

  handleSelect = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "company":
        this.setState({
          [name]: value ? JSON.parse(value) : "",
        });
        break;
      case "toWhom":
        if (value === "company") {
          this.setState({
            [name]: value,
            to: this.props.complaint.companyEmail,
          });
        } else if (value === "recipient") {
          this.setState({
            [name]: value,
            to: this.props.complaint.complainant.email,
          });
        }
        break;
      default:
        this.setState({ [name]: value });
        break;
    }
  };

  insertTemplate = (e) => {
    this.setState({ message: "<p>Regards,</p><p>NCCC Team</p>" });
    this.props.change("html", "<p>Regards,</p><p>NCCC Team</p>");
    //console.log(this.props);
    //dispatch(change)
  };

  deleteFile(index) {
    console.log("index: " + index, "length: " + this.state.files.length);
    let files = this.state.files;
    let newFiles = files.splice(index, 1);
    if (newFiles.length === 1 && index === 0) {
      newFiles = [];
    }
    this.setState({ files: newFiles });
    console.log(this.state.files);
  }

  //get files for attachments
  getFiles = (tempFiles) => {
    let joined = this.state.files.concat(tempFiles[0]);
    this.setState({ files: joined }, () =>
      console.log("files", this.state.files)
    );
  };
  addFileUploader() {
    let newfileUploader = this.state.fileUploader;
    newfileUploader.push(
      <FileUploader
        uploadFile={uploadFile}
        complaintId={this.state.complaintId}
        setTempFiles={this.getFiles}
      />
    );
    this.setState({ fileUploader: newfileUploader });
    console.log(this.state.fileUploader);
  }

  attachAttacements = (documents) => {
    var docArray = [];
    docArray = documents;
    var tempText = this.state.htmlText;
    console.log(documents, tempText);

    if (docArray && docArray?.length > 0) {
      var text = " ";
      docArray.forEach((document) => {
        text += `<p><a href=${document.fileUrl}>${document.fileName}</a></p>`;
      });
      console.log(text);
    } else {
      text = "";
    }
    this.setState({ ...this.state, htmlText: tempText + text });
  };

  modules = {
    toolbar: [
      [{ header: [1, 2, 3] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        ({ list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" }),
      ],
      [{ color: [] }, { background: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
  ];

  render() {
    const {
      complaint,
      pristine,
      submitting,
      closeModal,
      loading,
      handleSubmit,
      companies,
      uploadFile,
    } = this.props;
    const { fileUploader } = this.state;

    return (
      <Modal
        className=""
        open={true}
        toggle={closeModal}
        modalClassName="modal"
        fade={true}
        role="dialog"
      >
        <ModalHeader className="bg-primary1 text-white">Email</ModalHeader>
        <ModalBody>
          {complaint && complaint.agent.email ? (
            <Form onSubmit={handleSubmit(this.onFormSubmit)}>
              {/* <Button onClick={() => this.insertTemplate()}>
                Insert User Data
              </Button> */}
              <Fragment>
                <Row>
                  <Col>
                    <FormGroup>
                      <label htmlFor="toWhom">To</label>
                      <FormSelect
                        name="toWhom"
                        value={this.state.toWhom}
                        onChange={this.handleSelect}
                      >
                        <option value="">None</option>
                        <option value="company">Company</option>
                        <option value="recipient">Complainant</option>
                      </FormSelect>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {this.state.toWhom === "company" ? (
                      <>
                        <FormGroup>
                          <Row>
                            <Col>
                              <label htmlFor="company">Company</label>
                              <FormSelect
                                name="company"
                                value={JSON.stringify(this.state.company)}
                                onChange={this.handleSelect}
                              >
                                <option value="">None</option>
                                {companies && companies.length > 0
                                  ? companies.map((company) => (
                                      <option
                                        value={JSON.stringify(company)}
                                        key={company.name}
                                      >
                                        {company.name}
                                      </option>
                                    ))
                                  : ""}
                              </FormSelect>
                            </Col>
                          </Row>
                        </FormGroup>
                        {this.state.company ||
                        (this.state.toWhom === "company" &&
                          this.state.company === "") ? (
                          <>
                            <FormGroup>
                              <Row>
                                <Col>
                                  <label htmlFor="to">Contact</label>
                                  <FormSelect
                                    name="to"
                                    type="email"
                                    value={this.state.contact}
                                    onChange={this.handleSelect}
                                  >
                                    <option value="">None</option>
                                    {this.state.company &&
                                    this.state.company?.contactPersons?.length >
                                      0
                                      ? this.state.company.contactPersons.map(
                                          (contact) => (
                                            <option
                                              value={contact.email}
                                              key={contact.name}
                                            >
                                              {contact.name}
                                            </option>
                                          )
                                        )
                                      : ""}
                                  </FormSelect>
                                </Col>
                                <Col>
                                  <label htmlFor="to">Email</label>
                                  <FormInput
                                    name="to"
                                    type="email"
                                    multiple
                                    value={this.state.to}
                                    onChange={this.handleSelect}
                                  />
                                </Col>
                              </Row>
                            </FormGroup>
                            <FormGroup>
                              <Row>
                                {this.state.company?.contactPersons?.length >
                                  0 && (
                                  <>
                                    <Col>
                                      <label htmlFor="to">CC</label>
                                      <FormSelect
                                        name="ccSelect"
                                        type="email"
                                        value={this.state.cc.selectedOption}
                                        onChange={this.handleCCSelect}
                                      >
                                        <option value="">None</option>
                                        {this.state.company !== "" &&
                                        this.state.company?.contactPersons
                                          ?.length > 0
                                          ? this.state.company.contactPersons.map(
                                              (contact) => (
                                                <option
                                                  value={contact.email}
                                                  key={contact.name}
                                                >
                                                  {contact.name}
                                                </option>
                                              )
                                            )
                                          : ""}
                                      </FormSelect>
                                    </Col>
                                    <Col>
                                      <label htmlFor="to">Email</label>
                                      <FormInput
                                        readOnly
                                        name="selectedOption"
                                        type="email"
                                        multiple
                                        value={this.state.cc.selectedOption}
                                      />
                                    </Col>
                                  </>
                                )}
                              </Row>
                              <Row>
                                <Col>
                                  <label htmlFor="to">CC</label>
                                  <FormInput
                                    className="lowerCase"
                                    name="ccCustomEmail"
                                    value={this.state.cc.customEmail}
                                    onChange={this.handleCCTextInput}
                                  />
                                </Col>
                              </Row>
                            </FormGroup>{" "}
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      <FormGroup>
                        <Row>
                          <Col>
                            <label htmlFor="to">Email</label>
                            <FormInput
                              name="to"
                              type="email"
                              multiple
                              value={this.state.to}
                              onChange={this.handleSelect}
                            />
                          </Col>
                          <Col>
                            <label htmlFor="to">CC</label>
                            <FormInput
                              className="lowerCase"
                              name="ccCustomEmail"
                              value={this.state.cc.customEmail}
                              onChange={this.handleCCTextInput}
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <label htmlFor="subject">Subject</label>
                      <Field name="subject" type="text" component={TextInput} />
                    </FormGroup>
                  </Col>
                </Row>

                {/* TODO add file attachements here */}
                <Row>
                  <Col>
                    <FormGroup>
                      <label>Attachments</label>

                      <Row>
                        {this.state.files && this.state.files.length > 0
                          ? this.state.files.map((document) => {
                              return (
                                <Col md="12" key={document.name}>
                                  {document.name}
                                </Col>
                              );
                            })
                          : ""}
                      </Row>

                      <Row>
                        <Col>
                          <FileUploader
                            uploadFile={uploadFile}
                            complaintId={complaint.id}
                            loading={loading}
                            setTempFiles={this.getFiles}
                          />
                        </Col>

                        <Col>
                          <Button
                            onClick={() =>
                              this.attachAttacements(complaint.documents)
                            }
                          >
                            Attach All Attachments
                          </Button>
                        </Col>
                      </Row>

                      {fileUploader.length > 0
                        ? fileUploader.map((uploader, index) => {
                            return <div key={index}>{uploader}</div>;
                          })
                        : ""}
                    </FormGroup>
                  </Col>
                  <hr />
                </Row>
                <Row>
                  <FormGroup></FormGroup>
                </Row>

                <Field name="html" type="textarea" component={this.renderQuill}>
                  <div className="my-editing-area" />
                </Field>
              </Fragment>
              <div className="home-buttons d-flex w-100 justify-content-between">
                <Button
                  type="cancel"
                  theme="danger"
                  onClick={() => closeModal()}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  theme="success"
                  disabled={
                    pristine || submitting || !complaint.agent.email.length > 4
                  }
                >
                  Submit
                </Button>
              </div>
            </Form>
          ) : (
            <Fragment>
              No agent assigned yet. Please wait till agent assignment to start
              emailing. Please take note that agent assignment might take up to
              14 days due overwhelming complaints received.
              <div className="home-buttons d-flex w-100 justify-content-between mt-2">
                <Button
                  type="cancel"
                  theme="danger"
                  onClick={() => closeModal()}
                >
                  Cancel
                </Button>
              </div>
            </Fragment>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default compose(
  connect(mapState, actions),
  withFirestore,
  reduxForm({ form: "emailForm" })
)(AgentEmailForm);
